/* tslint:disable */
/* eslint-disable */
/**
 * E.ON Home Dashboard - API
 * This API provides access and control function for smart equipped homes. For near real-time information please use this API here https://sse-hems-dev2.eon.ooo/docs/. `[NOTE]` The access token for the current user session is also valid for the real-time API utilising SSE (Server Sent Event)
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: sebastian.eggers@eon.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  BadRequest,
  Conflict,
  CustomerGatewayHealthResponseModel,
  EfficiencyCheckV2ResponseModel,
  Forbidden,
  ForecastEfficiencyCheckModel,
  ForecastValuesResponseModel,
  InvertersMasterKeyRequestModel,
  NotFound,
  PVBatteryDeviceModel,
  PVBatteryResponseModel,
  PvBatteryAddModel,
  PvBatteryCarbonAvoidedResponseModel,
  PvBatteryCarbonAvoidedTotalResponseModel,
  PvBatteryEEG9DataResponseModel,
  PvBatteryEEG9DataUpdateModel,
  PvBatteryEEG9StatusResponseModel,
  PvBatteryForecastV2ResponseModel,
  PvBatteryHistoryAggregationResponseModel,
  PvBatteryHistorySummaryResponseModel,
  PvBatteryModifyModel,
  Unauthorized,
} from '../models';

export interface PvBatteryAddInvertersMasterKeyRequest {
    installationId: string;
    invertersMasterKeyRequestModel: InvertersMasterKeyRequestModel;
}

export interface PvBatteryAddPvBatteryRequest {
    pvBatteryAddModel?: PvBatteryAddModel;
}

export interface PvBatteryGetCarbonDioxideAvoidedAggregatedRequest {
    fromDate: string;
    toDate: string;
    aggregation?: string;
    handleGaps?: string;
}

export interface PvBatteryGetCarbonDioxideAvoidedTotalRequest {
    fromDate: string;
    toDate: string;
    aggregation?: string;
    handleGaps?: string;
}

export interface PvBatteryGetEfficiencyCheckRequest {
    fromDate: string;
    toDate: string;
}

export interface PvBatteryGetEfficiencyCheck1Request {
    fromDate: string;
    toDate: string;
}

export interface PvBatteryGetForecastAggregatedRequest {
    fromDate: string;
    toDate: string;
    interval?: string;
    aggregation?: string;
}

export interface PvBatteryGetForecastAggregated1Request {
    fromDate: string;
    toDate: string;
    interval?: string;
}

export interface PvBatteryGetHistoryAggregatedRequest {
    fromDate: string;
    toDate: string;
    interval?: string;
    aggregation?: string;
    handleGaps?: string;
}

export interface PvBatteryGetPvBatteryRequest {
    clearCache?: string;
}

export interface PvBatteryGetPvBatteryEeg9DataRequest {
    configurationId: string;
}

export interface PvBatteryGetPvBatteryEeg9StatusRequest {
    configurationId: string;
}

export interface PvBatteryUpdateEeg9ValuesRequest {
    configurationId: string;
    pvBatteryEEG9DataUpdateModel: PvBatteryEEG9DataUpdateModel;
}

export interface PvBatteryUpdatePvBatteryRequest {
    configurationId: string;
    pvBatteryModifyModel: PvBatteryModifyModel;
}

/**
 * 
 */
export class PvBatteryApi extends runtime.BaseAPI {

    /**
     * Used by GridX systems for Kostal inverters, awaiting master key input for enabling tcp/modbus network connection
     * Add master key for inverter
     */
    async pvBatteryAddInvertersMasterKeyRaw(requestParameters: PvBatteryAddInvertersMasterKeyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<object>> {
        if (requestParameters.installationId === null || requestParameters.installationId === undefined) {
            throw new runtime.RequiredError('installationId','Required parameter requestParameters.installationId was null or undefined when calling pvBatteryAddInvertersMasterKey.');
        }

        if (requestParameters.invertersMasterKeyRequestModel === null || requestParameters.invertersMasterKeyRequestModel === undefined) {
            throw new runtime.RequiredError('invertersMasterKeyRequestModel','Required parameter requestParameters.invertersMasterKeyRequestModel was null or undefined when calling pvBatteryAddInvertersMasterKey.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
        }

        const response = await this.request({
            path: `/api/v1/pvbattery/{installationId}/inverter-master-key`.replace(`{${"installationId"}}`, encodeURIComponent(String(requestParameters.installationId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.invertersMasterKeyRequestModel,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Used by GridX systems for Kostal inverters, awaiting master key input for enabling tcp/modbus network connection
     * Add master key for inverter
     */
    async pvBatteryAddInvertersMasterKey(requestParameters: PvBatteryAddInvertersMasterKeyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<object> {
        const response = await this.pvBatteryAddInvertersMasterKeyRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Used for PV self-onboarding. Does reverse lookup for the installation data and creates installation if device is found
     * Add PV & Battery device by serial number
     */
    async pvBatteryAddPvBatteryRaw(requestParameters: PvBatteryAddPvBatteryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PVBatteryResponseModel>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", ["policy/hems/energydevices/pvb:write"]);
        }

        const response = await this.request({
            path: `/api/v1/pvbattery`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.pvBatteryAddModel,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Used for PV self-onboarding. Does reverse lookup for the installation data and creates installation if device is found
     * Add PV & Battery device by serial number
     */
    async pvBatteryAddPvBattery(requestParameters: PvBatteryAddPvBatteryRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PVBatteryResponseModel> {
        const response = await this.pvBatteryAddPvBatteryRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get aggregated CO2 avoidance data based on PV generation (DEPRECATED)
     * Get the avoided CO2 in gramm for a give timeframe in watt aggregated by hour
     */
    async pvBatteryGetCarbonDioxideAvoidedAggregatedRaw(requestParameters: PvBatteryGetCarbonDioxideAvoidedAggregatedRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<PvBatteryCarbonAvoidedResponseModel>>> {
        if (requestParameters.fromDate === null || requestParameters.fromDate === undefined) {
            throw new runtime.RequiredError('fromDate','Required parameter requestParameters.fromDate was null or undefined when calling pvBatteryGetCarbonDioxideAvoidedAggregated.');
        }

        if (requestParameters.toDate === null || requestParameters.toDate === undefined) {
            throw new runtime.RequiredError('toDate','Required parameter requestParameters.toDate was null or undefined when calling pvBatteryGetCarbonDioxideAvoidedAggregated.');
        }

        const queryParameters: any = {};

        if (requestParameters.fromDate !== undefined) {
            queryParameters['fromDate'] = requestParameters.fromDate;
        }

        if (requestParameters.toDate !== undefined) {
            queryParameters['toDate'] = requestParameters.toDate;
        }

        if (requestParameters.aggregation !== undefined) {
            queryParameters['aggregation'] = requestParameters.aggregation;
        }

        if (requestParameters.handleGaps !== undefined) {
            queryParameters['handleGaps'] = requestParameters.handleGaps;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", ["policy/hems/carbondioxide/avoided:read"]);
        }

        const response = await this.request({
            path: `/api/v1/pvbattery/carbondioxide/avoided/aggregated`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Get aggregated CO2 avoidance data based on PV generation (DEPRECATED)
     * Get the avoided CO2 in gramm for a give timeframe in watt aggregated by hour
     */
    async pvBatteryGetCarbonDioxideAvoidedAggregated(requestParameters: PvBatteryGetCarbonDioxideAvoidedAggregatedRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<PvBatteryCarbonAvoidedResponseModel>> {
        const response = await this.pvBatteryGetCarbonDioxideAvoidedAggregatedRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get total CO2 avoidance value for a given timeframe (DEPRECATED)
     * Get the avoided CO2 in gramm for a given timeframe as a total value
     */
    async pvBatteryGetCarbonDioxideAvoidedTotalRaw(requestParameters: PvBatteryGetCarbonDioxideAvoidedTotalRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<PvBatteryCarbonAvoidedTotalResponseModel>>> {
        if (requestParameters.fromDate === null || requestParameters.fromDate === undefined) {
            throw new runtime.RequiredError('fromDate','Required parameter requestParameters.fromDate was null or undefined when calling pvBatteryGetCarbonDioxideAvoidedTotal.');
        }

        if (requestParameters.toDate === null || requestParameters.toDate === undefined) {
            throw new runtime.RequiredError('toDate','Required parameter requestParameters.toDate was null or undefined when calling pvBatteryGetCarbonDioxideAvoidedTotal.');
        }

        const queryParameters: any = {};

        if (requestParameters.fromDate !== undefined) {
            queryParameters['fromDate'] = requestParameters.fromDate;
        }

        if (requestParameters.toDate !== undefined) {
            queryParameters['toDate'] = requestParameters.toDate;
        }

        if (requestParameters.aggregation !== undefined) {
            queryParameters['aggregation'] = requestParameters.aggregation;
        }

        if (requestParameters.handleGaps !== undefined) {
            queryParameters['handleGaps'] = requestParameters.handleGaps;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", ["policy/hems/carbondioxide/avoided:read"]);
        }

        const response = await this.request({
            path: `/api/v1/pvbattery/carbondioxide/avoided/total`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Get total CO2 avoidance value for a given timeframe (DEPRECATED)
     * Get the avoided CO2 in gramm for a given timeframe as a total value
     */
    async pvBatteryGetCarbonDioxideAvoidedTotal(requestParameters: PvBatteryGetCarbonDioxideAvoidedTotalRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<PvBatteryCarbonAvoidedTotalResponseModel>> {
        const response = await this.pvBatteryGetCarbonDioxideAvoidedTotalRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get PV system efficiency check data (DEPRECATED - use v2 endpoints)
     * Get efficiency check data
     */
    async pvBatteryGetEfficiencyCheckRaw(requestParameters: PvBatteryGetEfficiencyCheckRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ForecastEfficiencyCheckModel>> {
        if (requestParameters.fromDate === null || requestParameters.fromDate === undefined) {
            throw new runtime.RequiredError('fromDate','Required parameter requestParameters.fromDate was null or undefined when calling pvBatteryGetEfficiencyCheck.');
        }

        if (requestParameters.toDate === null || requestParameters.toDate === undefined) {
            throw new runtime.RequiredError('toDate','Required parameter requestParameters.toDate was null or undefined when calling pvBatteryGetEfficiencyCheck.');
        }

        const queryParameters: any = {};

        if (requestParameters.fromDate !== undefined) {
            queryParameters['fromDate'] = requestParameters.fromDate;
        }

        if (requestParameters.toDate !== undefined) {
            queryParameters['toDate'] = requestParameters.toDate;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", ["policy/hems/forecast/pvforecast:read"]);
        }

        const response = await this.request({
            path: `/api/v1/pvbattery/efficiency`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Get PV system efficiency check data (DEPRECATED - use v2 endpoints)
     * Get efficiency check data
     */
    async pvBatteryGetEfficiencyCheck(requestParameters: PvBatteryGetEfficiencyCheckRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ForecastEfficiencyCheckModel> {
        const response = await this.pvBatteryGetEfficiencyCheckRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get efficiency check data for PV battery system within a specified date range
     * Get efficiency check data
     */
    async pvBatteryGetEfficiencyCheck1Raw(requestParameters: PvBatteryGetEfficiencyCheck1Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<EfficiencyCheckV2ResponseModel>>> {
        if (requestParameters.fromDate === null || requestParameters.fromDate === undefined) {
            throw new runtime.RequiredError('fromDate','Required parameter requestParameters.fromDate was null or undefined when calling pvBatteryGetEfficiencyCheck1.');
        }

        if (requestParameters.toDate === null || requestParameters.toDate === undefined) {
            throw new runtime.RequiredError('toDate','Required parameter requestParameters.toDate was null or undefined when calling pvBatteryGetEfficiencyCheck1.');
        }

        const queryParameters: any = {};

        if (requestParameters.fromDate !== undefined) {
            queryParameters['fromDate'] = requestParameters.fromDate;
        }

        if (requestParameters.toDate !== undefined) {
            queryParameters['toDate'] = requestParameters.toDate;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", ["policy/hems/forecast/pvforecast:read"]);
        }

        const response = await this.request({
            path: `/api/v2/pvbattery/efficiency`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Get efficiency check data for PV battery system within a specified date range
     * Get efficiency check data
     */
    async pvBatteryGetEfficiencyCheck1(requestParameters: PvBatteryGetEfficiencyCheck1Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<EfficiencyCheckV2ResponseModel>> {
        const response = await this.pvBatteryGetEfficiencyCheck1Raw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get PV forecast data with aggregation (DEPRECATED - use v2 endpoints)
     * Get forecast graph data
     */
    async pvBatteryGetForecastAggregatedRaw(requestParameters: PvBatteryGetForecastAggregatedRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<ForecastValuesResponseModel>>> {
        if (requestParameters.fromDate === null || requestParameters.fromDate === undefined) {
            throw new runtime.RequiredError('fromDate','Required parameter requestParameters.fromDate was null or undefined when calling pvBatteryGetForecastAggregated.');
        }

        if (requestParameters.toDate === null || requestParameters.toDate === undefined) {
            throw new runtime.RequiredError('toDate','Required parameter requestParameters.toDate was null or undefined when calling pvBatteryGetForecastAggregated.');
        }

        const queryParameters: any = {};

        if (requestParameters.fromDate !== undefined) {
            queryParameters['fromDate'] = requestParameters.fromDate;
        }

        if (requestParameters.toDate !== undefined) {
            queryParameters['toDate'] = requestParameters.toDate;
        }

        if (requestParameters.interval !== undefined) {
            queryParameters['interval'] = requestParameters.interval;
        }

        if (requestParameters.aggregation !== undefined) {
            queryParameters['aggregation'] = requestParameters.aggregation;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", ["policy/hems/forecast/pvforecast:read"]);
        }

        const response = await this.request({
            path: `/api/v1/pvbattery/forecast`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Get PV forecast data with aggregation (DEPRECATED - use v2 endpoints)
     * Get forecast graph data
     */
    async pvBatteryGetForecastAggregated(requestParameters: PvBatteryGetForecastAggregatedRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<ForecastValuesResponseModel>> {
        const response = await this.pvBatteryGetForecastAggregatedRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get PV battery forecast data aggregated over specified time intervals
     * Get forecast graph data
     */
    async pvBatteryGetForecastAggregated1Raw(requestParameters: PvBatteryGetForecastAggregated1Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<PvBatteryForecastV2ResponseModel>>> {
        if (requestParameters.fromDate === null || requestParameters.fromDate === undefined) {
            throw new runtime.RequiredError('fromDate','Required parameter requestParameters.fromDate was null or undefined when calling pvBatteryGetForecastAggregated1.');
        }

        if (requestParameters.toDate === null || requestParameters.toDate === undefined) {
            throw new runtime.RequiredError('toDate','Required parameter requestParameters.toDate was null or undefined when calling pvBatteryGetForecastAggregated1.');
        }

        const queryParameters: any = {};

        if (requestParameters.fromDate !== undefined) {
            queryParameters['fromDate'] = requestParameters.fromDate;
        }

        if (requestParameters.toDate !== undefined) {
            queryParameters['toDate'] = requestParameters.toDate;
        }

        if (requestParameters.interval !== undefined) {
            queryParameters['interval'] = requestParameters.interval;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", ["policy/hems/forecast/pvforecast:read"]);
        }

        const response = await this.request({
            path: `/api/v2/pvbattery/forecast`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Get PV battery forecast data aggregated over specified time intervals
     * Get forecast graph data
     */
    async pvBatteryGetForecastAggregated1(requestParameters: PvBatteryGetForecastAggregated1Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<PvBatteryForecastV2ResponseModel>> {
        const response = await this.pvBatteryGetForecastAggregated1Raw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Retrieve historical gateway status information for the authenticated customer
     * Get gateway status history for a customer
     */
    async pvBatteryGetGatewayHistoryRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CustomerGatewayHealthResponseModel>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", ["policy/hems/energydevices/pvb:read"]);
        }

        const response = await this.request({
            path: `/api/v1/pvbattery/gateway/history`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Retrieve historical gateway status information for the authenticated customer
     * Get gateway status history for a customer
     */
    async pvBatteryGetGatewayHistory(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CustomerGatewayHealthResponseModel> {
        const response = await this.pvBatteryGetGatewayHistoryRaw(initOverrides);
        return await response.value();
    }

    /**
     * Retrieve current gateway status information for the authenticated customer
     * Get gateway statuses for a customer
     */
    async pvBatteryGetGatewayStatusesRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CustomerGatewayHealthResponseModel>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", ["policy/hems/energydevices/pvb:read"]);
        }

        const response = await this.request({
            path: `/api/v1/pvbattery/gateway/status`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Retrieve current gateway status information for the authenticated customer
     * Get gateway statuses for a customer
     */
    async pvBatteryGetGatewayStatuses(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CustomerGatewayHealthResponseModel> {
        const response = await this.pvBatteryGetGatewayStatusesRaw(initOverrides);
        return await response.value();
    }

    /**
     * Get historical PV and battery data with aggregation (will be deprecated in v2)
     * Get history graph data
     */
    async pvBatteryGetHistoryAggregatedRaw(requestParameters: PvBatteryGetHistoryAggregatedRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<PvBatteryHistoryAggregationResponseModel>>> {
        if (requestParameters.fromDate === null || requestParameters.fromDate === undefined) {
            throw new runtime.RequiredError('fromDate','Required parameter requestParameters.fromDate was null or undefined when calling pvBatteryGetHistoryAggregated.');
        }

        if (requestParameters.toDate === null || requestParameters.toDate === undefined) {
            throw new runtime.RequiredError('toDate','Required parameter requestParameters.toDate was null or undefined when calling pvBatteryGetHistoryAggregated.');
        }

        const queryParameters: any = {};

        if (requestParameters.fromDate !== undefined) {
            queryParameters['fromDate'] = requestParameters.fromDate;
        }

        if (requestParameters.toDate !== undefined) {
            queryParameters['toDate'] = requestParameters.toDate;
        }

        if (requestParameters.interval !== undefined) {
            queryParameters['interval'] = requestParameters.interval;
        }

        if (requestParameters.aggregation !== undefined) {
            queryParameters['aggregation'] = requestParameters.aggregation;
        }

        if (requestParameters.handleGaps !== undefined) {
            queryParameters['handleGaps'] = requestParameters.handleGaps;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", ["policy/hems/energydevices/pvb:read"]);
        }

        const response = await this.request({
            path: `/api/v1/pvbattery/history/aggregated`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Get historical PV and battery data with aggregation (will be deprecated in v2)
     * Get history graph data
     */
    async pvBatteryGetHistoryAggregated(requestParameters: PvBatteryGetHistoryAggregatedRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<PvBatteryHistoryAggregationResponseModel>> {
        const response = await this.pvBatteryGetHistoryAggregatedRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get historical summary data (DEPRECATED - returns empty object)
     * Get history summary
     */
    async pvBatteryGetHistorySummaryRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PvBatteryHistorySummaryResponseModel>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", ["policy/hems/energydevices/pvb:read"]);
        }

        const response = await this.request({
            path: `/api/v1/pvbattery/history/summary`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Get historical summary data (DEPRECATED - returns empty object)
     * Get history summary
     */
    async pvBatteryGetHistorySummary(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PvBatteryHistorySummaryResponseModel> {
        const response = await this.pvBatteryGetHistorySummaryRaw(initOverrides);
        return await response.value();
    }

    /**
     * Retrieve all PV and battery devices for the authenticated user
     * Get PV & Battery devices
     */
    async pvBatteryGetPvBatteryRaw(requestParameters: PvBatteryGetPvBatteryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<PVBatteryDeviceModel>>> {
        const queryParameters: any = {};

        if (requestParameters.clearCache !== undefined) {
            queryParameters['clearCache'] = requestParameters.clearCache;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", ["policy/hems/energydevices/pvb:read"]);
        }

        const response = await this.request({
            path: `/api/v1/pvbattery`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Retrieve all PV and battery devices for the authenticated user
     * Get PV & Battery devices
     */
    async pvBatteryGetPvBattery(requestParameters: PvBatteryGetPvBatteryRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<PVBatteryDeviceModel>> {
        const response = await this.pvBatteryGetPvBatteryRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Retrieve PV nominal power and installation date information for EEG §9 compliance
     * GET Endpoint to provide PV nominal power and installation date for EEG §9
     */
    async pvBatteryGetPvBatteryEeg9DataRaw(requestParameters: PvBatteryGetPvBatteryEeg9DataRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PvBatteryEEG9DataResponseModel>> {
        if (requestParameters.configurationId === null || requestParameters.configurationId === undefined) {
            throw new runtime.RequiredError('configurationId','Required parameter requestParameters.configurationId was null or undefined when calling pvBatteryGetPvBatteryEeg9Data.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", ["policy/hems/energydevices/pvb:read"]);
        }

        const response = await this.request({
            path: `/api/v1/pvbattery/{configurationId}/eeg9/installation`.replace(`{${"configurationId"}}`, encodeURIComponent(String(requestParameters.configurationId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Retrieve PV nominal power and installation date information for EEG §9 compliance
     * GET Endpoint to provide PV nominal power and installation date for EEG §9
     */
    async pvBatteryGetPvBatteryEeg9Data(requestParameters: PvBatteryGetPvBatteryEeg9DataRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PvBatteryEEG9DataResponseModel> {
        const response = await this.pvBatteryGetPvBatteryEeg9DataRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Retrieve the current status of EEG §9 reminder sent flag
     * GET Endpoint to retrieve EEG §9 reminder sent flag status
     */
    async pvBatteryGetPvBatteryEeg9ReminderSentRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<boolean>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", ["policy/hems/energydevices/pvb:write"]);
        }

        const response = await this.request({
            path: `/api/v1/pvbattery/eeg9/reminder`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.TextApiResponse(response) as any;
    }

    /**
     * Retrieve the current status of EEG §9 reminder sent flag
     * GET Endpoint to retrieve EEG §9 reminder sent flag status
     */
    async pvBatteryGetPvBatteryEeg9ReminderSent(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<boolean> {
        const response = await this.pvBatteryGetPvBatteryEeg9ReminderSentRaw(initOverrides);
        return await response.value();
    }

    /**
     * Retrieve current EEG §9 compliance status for the specified configuration
     * GET Endpoint to provide EEG §9 status
     */
    async pvBatteryGetPvBatteryEeg9StatusRaw(requestParameters: PvBatteryGetPvBatteryEeg9StatusRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PvBatteryEEG9StatusResponseModel>> {
        if (requestParameters.configurationId === null || requestParameters.configurationId === undefined) {
            throw new runtime.RequiredError('configurationId','Required parameter requestParameters.configurationId was null or undefined when calling pvBatteryGetPvBatteryEeg9Status.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", ["policy/hems/energydevices/pvb:read"]);
        }

        const response = await this.request({
            path: `/api/v1/pvbattery/{configurationId}/eeg9/status`.replace(`{${"configurationId"}}`, encodeURIComponent(String(requestParameters.configurationId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Retrieve current EEG §9 compliance status for the specified configuration
     * GET Endpoint to provide EEG §9 status
     */
    async pvBatteryGetPvBatteryEeg9Status(requestParameters: PvBatteryGetPvBatteryEeg9StatusRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PvBatteryEEG9StatusResponseModel> {
        const response = await this.pvBatteryGetPvBatteryEeg9StatusRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Set the EEG §9 reminder sent flag to indicate reminder has been sent to user
     * POST Endpoint to set EEG §9 reminder sent flag
     */
    async pvBatterySetPvBatteryEeg9ReminderSentRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", ["policy/hems/energydevices/pvb:write"]);
        }

        const response = await this.request({
            path: `/api/v1/pvbattery/eeg9/reminder`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Set the EEG §9 reminder sent flag to indicate reminder has been sent to user
     * POST Endpoint to set EEG §9 reminder sent flag
     */
    async pvBatterySetPvBatteryEeg9ReminderSent(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.pvBatterySetPvBatteryEeg9ReminderSentRaw(initOverrides);
    }

    /**
     * EEG9 manage PV page, updates nominal power and installation dates in Xenon
     * Update norminal power and installation date
     */
    async pvBatteryUpdateEeg9ValuesRaw(requestParameters: PvBatteryUpdateEeg9ValuesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PvBatteryEEG9DataResponseModel>> {
        if (requestParameters.configurationId === null || requestParameters.configurationId === undefined) {
            throw new runtime.RequiredError('configurationId','Required parameter requestParameters.configurationId was null or undefined when calling pvBatteryUpdateEeg9Values.');
        }

        if (requestParameters.pvBatteryEEG9DataUpdateModel === null || requestParameters.pvBatteryEEG9DataUpdateModel === undefined) {
            throw new runtime.RequiredError('pvBatteryEEG9DataUpdateModel','Required parameter requestParameters.pvBatteryEEG9DataUpdateModel was null or undefined when calling pvBatteryUpdateEeg9Values.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", ["policy/hems/energydevices/pvb:write"]);
        }

        const response = await this.request({
            path: `/api/v1/pvbattery/{configurationId}/eeg9/installation`.replace(`{${"configurationId"}}`, encodeURIComponent(String(requestParameters.configurationId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.pvBatteryEEG9DataUpdateModel,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * EEG9 manage PV page, updates nominal power and installation dates in Xenon
     * Update norminal power and installation date
     */
    async pvBatteryUpdateEeg9Values(requestParameters: PvBatteryUpdateEeg9ValuesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PvBatteryEEG9DataResponseModel> {
        const response = await this.pvBatteryUpdateEeg9ValuesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update configuration settings for a specific PV and battery device
     * Update PV & Battery device
     */
    async pvBatteryUpdatePvBatteryRaw(requestParameters: PvBatteryUpdatePvBatteryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PVBatteryDeviceModel>> {
        if (requestParameters.configurationId === null || requestParameters.configurationId === undefined) {
            throw new runtime.RequiredError('configurationId','Required parameter requestParameters.configurationId was null or undefined when calling pvBatteryUpdatePvBattery.');
        }

        if (requestParameters.pvBatteryModifyModel === null || requestParameters.pvBatteryModifyModel === undefined) {
            throw new runtime.RequiredError('pvBatteryModifyModel','Required parameter requestParameters.pvBatteryModifyModel was null or undefined when calling pvBatteryUpdatePvBattery.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", ["policy/hems/energydevices/pvb:write"]);
        }

        const response = await this.request({
            path: `/api/v1/pvbattery/{configurationId}`.replace(`{${"configurationId"}}`, encodeURIComponent(String(requestParameters.configurationId))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.pvBatteryModifyModel,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Update configuration settings for a specific PV and battery device
     * Update PV & Battery device
     */
    async pvBatteryUpdatePvBattery(requestParameters: PvBatteryUpdatePvBatteryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PVBatteryDeviceModel> {
        const response = await this.pvBatteryUpdatePvBatteryRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
